(() => {
  if (window.bymjmTsTrial) return;
  window.bymjmTsTrial = true;
  const base = 'https://bol-mcp.mvdelzen.nl/bymjm-reviews/v1/';
  const read = async (path) => {
    const url = new URL(path, base);
    if (!url.href.startsWith(base)) throw new Error('Invalid review path');
    const response = await fetch(url, {credentials: 'omit', signal: AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error('Review data unavailable');
    return response.json();
  };
  const node = (tag, className, value) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (value !== undefined) element.textContent = value;
    return element;
  };
  function compactColumns(panel) {
    const proof=panel.closest('.bymjm-proof');
    if(!proof||proof.dataset.compactColumns)return;
    const details=proof.parentElement.querySelector('.bymjm-content-grid');
    const description=details?.querySelector(':scope > .bymjm-description');
    const side=details?.querySelector(':scope > .bymjm-side-column');
    const why=proof.querySelector(':scope > .bymjm-why');
    if(!description||!side||!why)return;
    const main=node('div','bymjm-proof-main');
    const sidebar=node('div','bymjm-proof-sidebar');
    main.append(panel,description);sidebar.append(why,side);proof.append(main,sidebar);
    proof.classList.add('bymjm-proof--compact');proof.dataset.compactColumns='true';
    if(!details.children.length)details.remove();
  }
  async function init(panel) {
    if (panel.dataset.tsStarted) return;
    panel.dataset.tsStarted = 'true';
    compactColumns(panel);
    const labels = JSON.parse(panel.querySelector('[data-ts-labels]').textContent);
    const status = panel.querySelector('[data-ts-status]');
    try {
      const originResponse = await fetch(panel.dataset.tsOriginUrl, {credentials: 'omit', signal: AbortSignal.timeout(15000)});
      if (!originResponse.ok) throw new Error('Review origins unavailable');
      const origins = await originResponse.json();
      if (origins.schema_version !== 1 || !origins.matches) throw new Error('Invalid review origins');
      const summary = await read('summary.json');
      const skus = panel.dataset.tsSkus.split(',');
      const availableSkus = skus.filter(sku => summary.products?.[sku]?.path);
      if (!availableSkus.length) {
        panel.hidden = true;
        panel.closest('.bymjm-proof')?.classList.add('bymjm-proof--no-reviews');
        panel.dataset.tsLoaded = 'true';
        panel.dataset.tsCount = '0';
        return;
      }
      const results = await Promise.all(availableSkus.map(sku => read(summary.products[sku].path)));
      if (results.some((result, index) => result.sku !== availableSkus[index] || !Array.isArray(result.reviews) || result.reviews.length !== summary.products[availableSkus[index]].count)) throw new Error('Incomplete review data');
      const unique = new Map();
      results.forEach(result => result.reviews.forEach(review => {
        const rating = Number(review.rating);
        if (review.type !== 'product' || !review.id || !Number.isFinite(rating) || rating < 1 || rating > 5) throw new Error('Invalid product review');
        const origin = origins.matches[review.id];
        const matched = origin && origin.sku === result.sku && origin.date === review.date &&
          Number(origin.rating) === rating && origin.title === (review.title || '') && origin.comment === (review.comment || '');
        const canonicalId = matched ? 'original:' + origin.canonicalId : 'trusted:' + review.id;
        if (!unique.has(canonicalId)) {
          unique.set(canonicalId, {...review, canonicalId,
            displayName: matched ? origin.displayName : (typeof review.displayName === 'string' ? review.displayName : '')});
        }
      }));
      const reviews = [...unique.values()].sort((a, b) => new Date(b.date) - new Date(a.date));
      if (!reviews.length) throw new Error('No reviews');
      const average = reviews.reduce((sum, review) => sum + Number(review.rating), 0) / reviews.length;
      const locale = panel.dataset.tsLocale || 'nl';
      const score = new Intl.NumberFormat(locale, {minimumFractionDigits: 1, maximumFractionDigits: 1}).format(average);
      const plural = new Intl.PluralRules(locale).select(reviews.length);
      const countWord = labels['count' + plural.charAt(0).toUpperCase() + plural.slice(1)] || labels.count;
      const count = new Intl.NumberFormat(locale).format(reviews.length) + ' ' + countWord;
      document.querySelectorAll('[data-ts-badge]').forEach(badge => {
        if (badge.getAttribute('href') !== '#' + panel.id) return;
        const intro = badge.closest('.product__info-container')?.querySelector('.bymjm-short-intro');
        if (intro) intro.after(badge);
        badge.querySelector('[data-ts-rating]').textContent = score + '/5';
        badge.querySelector('[data-ts-count]').textContent = count;
        badge.querySelectorAll('[data-ts-star-stop]').forEach(stop => stop.setAttribute('offset', (average / 5 * 100) + '%'));
        badge.setAttribute('aria-label', score + ' ' + labels.outOf + ', ' + count);
        badge.hidden = false;
      });
      const heading = panel.querySelector('[data-ts-summary]');
      heading.textContent = score + '/5 · ' + count;
      heading.hidden = false;
      const cards = panel.querySelector('[data-ts-cards]');
      const more = panel.querySelector('[data-ts-more]');
      const dateFormat = new Intl.DateTimeFormat(locale, {day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'});
      let shown = 0;
      const show = () => {
        const end = Math.min(shown + (shown ? 10 : 3), reviews.length);
        const fragment = document.createDocumentFragment();
        for (; shown < end; shown++) {
          const review = reviews[shown];
          const card = node('article', 'bymjm-ts-card');
          card.dataset.reviewId = review.id;
          card.dataset.canonicalId = review.canonicalId;
          const header = node('header');
          const stars = document.createElementNS('http://www.w3.org/2000/svg','svg');
          stars.classList.add('bymjm-ts-stars');
          stars.setAttribute('viewBox','0 0 120 24');stars.setAttribute('width','100');stars.setAttribute('height','20');stars.setAttribute('focusable','false');
          const starPath = 'M12 1 L14.7 9.3 L23.4 9.3 L16.35 14.4 L19.05 22.7 L12 17.6 L4.95 22.7 L7.65 14.4 L0.6 9.3 L9.3 9.3Z';
          for (let index=0;index<5;index++) {const star=document.createElementNS('http://www.w3.org/2000/svg','path');star.setAttribute('d',starPath);star.setAttribute('transform','translate('+(index*24)+' 0)');star.setAttribute('fill',index<Math.round(review.rating)?'#ef6618':'#e5e5e5');stars.append(star);}
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', review.rating + ' ' + labels.outOf);
          header.append(stars);
          const date = new Date(review.date);
          if (Number.isFinite(date.getTime())) {
            const time = node('time', '', dateFormat.format(date));
            time.dateTime = date.toISOString();
            header.append(time);
          }
          card.append(header);
          if (review.title) card.append(node('h3', '', review.title));
          if (review.comment) {
            const text=node('p','bymjm-ts-review-text',review.comment);
            text.id=panel.id+'-text-'+shown;
            const toggle=node('button','bymjm-ts-read-more',labels.readMore);
            toggle.type='button';toggle.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-controls',text.id);
            toggle.addEventListener('click',()=>{const expanded=text.classList.toggle('bymjm-ts-review-text--expanded');toggle.setAttribute('aria-expanded',String(expanded));toggle.textContent=expanded?labels.readLess:labels.readMore;});
            card.append(text,toggle);
          }
          if (review.locale) card.lang = review.locale.replace('_', '-');
          if (review.displayName) card.append(node('footer', 'bymjm-ts-author', '— ' + review.displayName));
          fragment.append(card);
        }
        cards.append(fragment);
        requestAnimationFrame(()=>{cards.querySelectorAll('.bymjm-ts-review-text:not(.bymjm-ts-review-text--expanded)').forEach(text=>{const toggle=text.nextElementSibling;if(toggle?.classList.contains('bymjm-ts-read-more'))toggle.hidden=text.scrollHeight<=text.clientHeight;});});
        more.hidden = shown >= reviews.length;
        more.textContent = labels.more + ' (' + (reviews.length - shown) + ')';
      };
      more.addEventListener('click', show);
      show();
      status.hidden = true;
      panel.dataset.tsLoaded = 'true';
      panel.dataset.tsCount = String(reviews.length);
      panel.dataset.tsAverage = String(average);
      panel.dataset.tsGeneratedAt = summary.generated_at;
    } catch (error) {
      status.textContent = labels.unavailable;
      panel.dataset.tsError = 'true';
    }
  }
  const start = () => document.querySelectorAll('[data-ts-panel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();





